import { useState, useCallback } from "react";
import { Auth } from "aws-amplify";
import { mutationAccountSignOut } from "src/graphql";
import { logoutEmit } from "src/utils/event";
import { useSignOut } from "src/hooks";

export const useLogout = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  const authSignOut = useSignOut();
  const logoutHandler = useCallback(async () => {
    setError(undefined);
    setLoading(true);
    try {
      await mutationAccountSignOut();
      await authSignOut();
      logoutEmit();
      setLoading(false);
    } catch (e) {
      console.error(e);
      setError(e as Error);
      setLoading(false);
    }
  }, []);

  return [logoutHandler, loading, error] as const;
};
